function accordion(element) {
	$(window).on('load', function() {
		$('.accordion')
			.slice(0, 1)
			.addClass('active')
			.find('.accordion__content')
			.slideToggle();
	});

	$(element).on('click', function() {
		const $this = $(this);
		const $accordion = $this.closest('.accordion');
		const $isActive = $accordion.is('.active');
		if ($isActive) {
			$accordion.toggleClass('active');
			$accordion.find('.accordion__content').slideToggle();
		} else {
			$('.accordion')
				.removeClass('active')
				.find('.accordion__content')
				.slideUp();
			$accordion
				.find('.accordion__content')
				.slideToggle()
				.closest('.accordion')
				.addClass('active');
		}
	});
}

module.exports = {
	accordion
};
